import React from 'react'
import ReactModal from 'react-modal'


const Modal = ({ showModal, children, customStyle, hideModal }) => {
  const padding = 90 // adjust this to your needs
  let height = 400 + padding
  let heightPx = height + 'px'
  let heightOffset = height / 2
  let offsetPx = heightOffset + 'px'

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem'
  }
  return (
 
    <ReactModal
      ariaHideApp={false}
      isOpen={showModal}
      onRequestClose={hideModal} 
      shouldCloseOnOverlayClick={true} 
      style={{
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)',zIndex:9999 },
        content: customStyle ? customStyle : style
      }}
    >

      {children}
    </ReactModal>
  )
}

export default Modal
